import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const apiCalls = {};

apiCalls.fetchProperties = async () => {
    const { data } = await api.get('/properties');

    return data;
};

apiCalls.fetchProperty = async propertyId => {
    const { data } = await api.get(`/properties/${propertyId}`);

    return data;
};

apiCalls.createProperty = async payload => {
    const { data } = await api.post('/properties', payload);

    return data;
};

apiCalls.updateProperty = async (id, payload) => {
    const { data } = await api.put(`/properties/${id}`, payload);

    return data;
};

apiCalls.deleteProperty = async propertyId => {
    const { data } = await api.delete(`/properties/${propertyId}`);

    return data;
};

export const useProperty = (propertyId, queryOptions = {}) => useQuery(['property', propertyId], () => apiCalls.fetchProperty(propertyId), {
    //cacheTime: 300000,
    ...queryOptions
});


export const useProperties = (queryOptions = {}) => useQuery('properties', apiCalls.fetchProperties, {
    cacheTime: 0,
    ...queryOptions
});

export const useUpdateProperty = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ id, payload }) => apiCalls.updateProperty(id, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('properties');
        },
        ...queryOptions
    });
};

export const useCreateProperty = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => apiCalls.createProperty(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('properties');
        },
        ...queryOptions
    });
};

export const useDeleteProperty = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(propertyId => apiCalls.deleteProperty(propertyId), {
        onSuccess: () => {
            queryClient.invalidateQueries('properties');
        },
        ...queryOptions
    });
};
